import { EndSessionWarningModalService } from '@app/components/modals/end-session-warning-modal/end-session-warning.modal-service';
import { BaseModalComponent } from '@app/components/modals/base/base-modal.component';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-end-session-warning-modal',
	templateUrl: './end-session-warning-modal.component.html',
	styleUrls: ['./end-session-warning-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EndSessionWarningModalComponent extends BaseModalComponent {
	protected _title = 'Session timeout warning';

	constructor(private service: EndSessionWarningModalService) {
		super();
	}

	public continueSession(): void {
		this.continueSession$().subscribe(() => this._hideFunc());
	}

	public endSession(): void {
		this.service.endSession();
	}

	public onBackdropClick(): Observable<void> {
		return this.continueSession$();
	}

	private continueSession$(): Observable<void> {
		return this.service.continueSession();
	}
}
